import { Box, Button, Spinner } from '@palmetto/palmetto-components';
import { skipToken } from '@reduxjs/toolkit/query/react';
import { useCallback } from 'react';
import { useParams } from 'react-router-dom';

import { useGetAccountActivityCursorInfiniteQuery } from '../../services/accounts';

import { InfiniteActivityList } from './InfiniteActivityList';

export const AccountActivity = () => {
  const { id } = useParams<{ id: any }>();
  const {
    data: test,
    fetchNextPage,
    isLoading: isActivityLoading,
    isFetchingNextPage,
    refetch,
  } = useGetAccountActivityCursorInfiniteQuery(id ?? skipToken);

  const handleRefresh = useCallback(() => {
    refetch();
  }, [refetch]);

  const isLoading = isActivityLoading || isFetchingNextPage;

  return (
    <Box display="block" childGap="sm">
      {!isLoading && (
        <Box alignItems={{ base: 'stretch', tablet: 'flex-start' }} padding={{ base: '0 lg', desktop: '0' }}>
          <Button
            iconPrefix="refresh"
            variant="secondary"
            tone="neutral"
            size="sm"
            isLoading={isLoading}
            onClick={handleRefresh}
          >
            refresh
          </Button>
        </Box>
      )}
      <Box>
        {isActivityLoading ? (
          <Spinner size="lg" />
        ) : (
          <InfiniteActivityList
            activities={test?.pages.flatMap((page) => page.data)}
            fetchNextPage={fetchNextPage}
            isLoading={isLoading}
            hasMore={test?.pages[test.pages.length - 1]?.nextCursor != null || false}
          />
        )}
      </Box>
    </Box>
  );
};
